import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectSurfaceActionsOption')(function selectSurfaceActionsOption(option, actionCollection, actionKey, checked, state) {
    var optionState = state.optionState;
    if (checked) {
        if (actionCollection.indexOf(actionKey) == -1) {
            actionCollection.push(actionKey);
        }
    }
    else {
        var index = actionCollection.indexOf(actionKey);
        if (index >= 0) {
            actionCollection.splice(index, 1);
        }
    }
    optionState[option] = actionCollection;
}));
//# sourceMappingURL=selectSurfaceActionsOption.js.map